import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import Popper from 'popper.js';
import { useState, useRef, useEffect } from 'react';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function calculateOffset(_ref) {
  var offset = _ref.offset,
      showArrow = _ref.showArrow;
  var arrowSize = 10;
  var defaultPadding = 3;
  return {
    enabled: showArrow || offset,
    offset: Array.isArray(offset) ? "".concat(offset[0], ", ").concat((offset[1] || offset[0]) + arrowSize + defaultPadding) : "0, ".concat(arrowSize + defaultPadding)
  };
}

function usePopper(_ref2) {
  var offset = _ref2.offset,
      showArrow = _ref2.showArrow,
      placement = _ref2.placement,
      isOpen = _ref2.isOpen,
      modifiers = _ref2.modifiers,
      _ref2$eventsEnabled = _ref2.eventsEnabled,
      eventsEnabled = _ref2$eventsEnabled === void 0 ? true : _ref2$eventsEnabled,
      positionFixed = _ref2.positionFixed,
      _ref2$boundaries = _ref2.boundaries,
      boundaries = _ref2$boundaries === void 0 ? 'scrollParent' : _ref2$boundaries,
      refEl = _ref2.referenceEl;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      popperData = _useState2[0],
      setPopperData = _useState2[1]; // this is util for deferred rendering like with portals


  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      dynamicPopperNode = _useState4[0],
      setPopperNode = _useState4[1];

  var referenceRef = useRef();
  var popperRef = useRef();
  var arrowRef = useRef();
  var popper = useRef(); // initialize popper with refs and options

  useEffect(function () {
    var referenceEl = refEl || referenceRef.current;
    var popperEl = dynamicPopperNode || popperRef.current;
    var arrowEl = arrowRef.current;
    popper.current = referenceEl && popperEl && new Popper(referenceEl, popperEl, {
      placement: placement,
      isOpen: isOpen,
      eventsEnabled: eventsEnabled,
      positionFixed: positionFixed,
      modifiers: _objectSpread(_objectSpread({
        preventOverflow: _objectSpread({
          padding: 0,
          boundariesElement: boundaries
        }, modifiers.preventOverflow),
        offset: calculateOffset({
          offset: offset,
          showArrow: showArrow
        })
      }, modifiers), {}, {
        arrow: {
          enabled: !!arrowEl,
          element: arrowEl
        },
        applyStyle: {
          enabled: false
        },
        updateStateModifier: {
          order: 900,
          enabled: true,
          fn: function fn(data) {
            setPopperData(data);
            return data;
          }
        }
      })
    });
    return function () {
      if (popper.current) popper.current.destroy();
    };
  }, [refEl, dynamicPopperNode, placement, showArrow, offset, popperRef, eventsEnabled]); // update popper instance after initialization

  useEffect(function () {
    if (!popper.current) return;
    popper.current.update();
  }, [popper.current]);
  var arrow = {
    ref: arrowRef,
    style: popperData.arrowStyles
  };
  var popperProps = {
    style: popperData.styles,
    ref: setPopperNode,
    placement: popperData.placement,
    'data-testid': 'popover-container'
  };
  var reference = {
    ref: referenceRef
  };
  return {
    popperInstance: popper.current,
    popper: popperProps,
    arrow: arrow,
    reference: reference,
    // setPopperNode,
    popperData: popperData
  };
}

export default usePopper;
//# sourceMappingURL=usePopper.js.map
